import * as React from 'react';

import {TimelineEntryActionMenu} from 'shells/timeline/entry/toolbar/timeline-entry-action-menu';
import type {Reaction, Reactions} from 'shells/timeline/reaction-bar/types';

import type {EventFragmentFull} from 'nutshell-graphql-types';

import {getEntryTypeFromPayload} from '../helpers';
import {getCommentsWithFilteredReactions} from '../reactions/helpers';

import {TimelineEntryModal} from './timeline-entry-modal';

import styles from '../entry/timeline-entry-content.module.css';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    currentUserId: string;
    event: EventFragmentFull;
    isLoading?: boolean;
    onToggleReaction: (
        changeLogId: string,
        reactionType: Reaction,
        filteredReactions: Reactions,
        parentChangeLogId?: string
    ) => any;
    filteredEntryReactions: Reactions;
    onAddComment: (value: string) => Promise<any>;
    onDeleteComment: (commentId: string) => Promise<any>;
    onDeleteEvent: (arg1: string) => Promise<any>;
};

export function TimelineNoteModal(props: Props) {
    const {
        event,
        isOpen,
        onClose,
        isLoading,
        currentUserId,
        onToggleReaction,
        filteredEntryReactions,
        onAddComment,
        onDeleteComment,
        onDeleteEvent,
    } = props;
    const {payload} = event;

    /**
     * We need to include this check, even though we are only passing an event
     * with a payload.__typename of 'Note' because Apollo doesn't generate a specific
     * enough type when using a union type (like the TimelineEventPayload).
     * See this issue for more detail:
     * https://github.com/apollographql/apollo-tooling/issues/1223
     */
    if (payload.__typename === 'Note') {
        const actionMenu = (
            <TimelineEntryActionMenu
                id={event.id}
                entryType={getEntryTypeFromPayload(payload)}
                handleDelete={(id) => onDeleteEvent(id).then(() => onClose())}
            />
        );

        return (
            <TimelineEntryModal
                isOpen={isOpen}
                onClose={onClose}
                status={
                    payload.isDeleted ? {primary: {level: 'alert', text: 'Deleted'}} : undefined
                }
                isLoading={isLoading}
                iconVariant='note'
                timestamp={event.changeTime}
                actor={event.actor}
                entity={payload.entity}
                entryType={getEntryTypeFromPayload(payload)}
                changeType={event.changeType}
                content={
                    <div
                        dangerouslySetInnerHTML={{
                            // @ts-expect-error
                            __html: payload.bodyHtml,
                        }}
                        className={styles['entry-html-body']}
                    />
                }
                filteredEntryReactions={filteredEntryReactions}
                currentUserId={currentUserId}
                changeLogId={event.id}
                onToggleReaction={onToggleReaction}
                comments={getCommentsWithFilteredReactions(event.comments)}
                onAddComment={onAddComment}
                onDeleteComment={onDeleteComment}
                actionMenu={actionMenu}
            />
        );
    }

    return null;
}
